<template>
  <div class="qianqing-timing-task">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :col="3"
      :columns="columns"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :requestPromise="loadDataList"
      :page-size="10"
    >
      <template v-slot:ruleInfo="{ record }">
        <div class="rule-info">
          <div class="rule-name">{{ record.taskName || '-' }}</div>
          <div class="rule-sub">同步范围：{{ getSyncScopeText(record.syncScope) }}</div>
          <div v-if="Number(record.syncScope) === 2" class="rule-sub">
            指定线路：{{ formatLineIds(record.specifiedLineCodes) }}
          </div>
          <div class="rule-sub">
            同行价 {{ formatPercent(record.peerPricePercent) }}
            / 佣金 {{ formatPercent(record.commissionPercent) }}
            / 市场价 {{ formatPercent(record.marketPricePercent) }}
            / 采购价 {{ formatPercent(record.purchasePricePercent) }}
          </div>
          <div class="rule-sub">
            商品信息：每 {{ record.productIntervalMinutes || '-' }} 分钟
            {{ getUpdateModeText(record.productUpdateMode, 'product') }}；
            价格库存：每 {{ record.priceIntervalMinutes || '-' }} 分钟
            {{ getUpdateModeText(record.priceUpdateMode, 'price') }}
          </div>
        </div>
      </template>
      <template v-slot:enabled="{ text }">
        <a-badge :status="Number(text) === 1 ? 'success' : 'default'" :text="getEnabledText(text)" />
      </template>
      <template v-slot:updateTime="{ text }">
        {{ formatTime(text) }}
      </template>
      <template v-slot:action="{ record }">
        <a-space>
          <a-popconfirm
            :title="Number(record.enabled) === 1 ? '确认关闭该定时任务？' : '确认开启该定时任务？'"
            @confirm="onToggleEnabled(record)"
          >
            <a>{{ Number(record.enabled) === 1 ? '关闭' : '开启' }}</a>
          </a-popconfirm>
          <a @click="openModal(record, 'edit')">编辑</a>
          <a @click="openModal(record, 'view')">查看</a>
        </a-space>
      </template>
    </StandardSearchPageView>

    <TimingTaskFormModal
      :visible.sync="modalVisible"
      :mode="modalMode"
      :task-id="currentTaskId"
      @success="refreshTable"
    />
  </div>
</template>

<script>
import moment from 'moment'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import QianqingMixins from '@/views/resource/qianqing/mixins/QianqingMixins'
import TimingTaskFormModal from './TimingTaskFormModal.vue'
import {
  formatPercent,
  formatLineIds,
  getEnabledText,
  getSyncScopeText,
  getUpdateModeText
} from '../utils/syncConfigHelper'

export default {
  name: 'TimingTaskComponent',
  components: {
    StandardSearchPageView,
    TimingTaskFormModal
  },
  mixins: [QianqingMixins],
  data () {
    return {
      modalVisible: false,
      modalMode: 'edit',
      currentTaskId: undefined,
      queryParams: {
        taskName: '',
        enabled: undefined
      },
      searchOptions: [
        {
          name: '任务名称',
          key: 'taskName',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '状态',
          key: 'enabled',
          type: 'select',
          placeholder: '请选择',
          allowClear: true,
          selectOptions: [
            { label: '启用', value: 1 },
            { label: '屏蔽', value: 0 }
          ]
        }
      ],
      columns: [
        {
          title: '规则ID',
          dataIndex: 'id',
          width: 100
        },
        {
          title: '规则信息',
          dataIndex: 'ruleInfo',
          scopedSlots: { customRender: 'ruleInfo' }
        },
        {
          title: '状态',
          dataIndex: 'enabled',
          width: 120,
          scopedSlots: { customRender: 'enabled' }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: 180,
          scopedSlots: { customRender: 'updateTime' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 180,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    formatPercent,
    formatLineIds,
    getEnabledText,
    getSyncScopeText,
    getUpdateModeText,
    formatTime (value) {
      if (!value) return '-'
      const time = moment(value)
      return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : value
    },
    loadDataList (params) {
      return this.getHttpServices()
        .getSourceService()
        .post('/qianqing/syncConfig/list', this.buildListParams(params))
        .then(this.normalizePageResult)
    },
    openModal (record, mode) {
      if (!record || record.id == null) {
        this.$message.error('任务配置ID缺失')
        return
      }
      this.modalMode = mode
      this.currentTaskId = record.id
      this.modalVisible = true
    },
    onToggleEnabled (record) {
      if (!record || record.id == null) {
        this.$message.error('任务配置ID缺失')
        return
      }
      const willEnable = Number(record.enabled) !== 1
      this.getHttpServices()
        .getSourceService()
        .post(`/qianqing/syncConfig/toggleEnabled?id=${encodeURIComponent(record.id)}`)
        .then((res) => {
          const nextEnabled = res === 0 || res === 1 ? res : (willEnable ? 1 : 0)
          this.$set(record, 'enabled', nextEnabled)
          this.$message.success(Number(nextEnabled) === 1 ? '已开启' : '已关闭')
          this.refreshTable()
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '切换状态失败，请重试')
        })
    }
  }
}
</script>

<style scoped lang="less">
.qianqing-timing-task {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.rule-info {
  padding: 4px 0;
  line-height: 1.6;
}

.rule-name {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.rule-sub {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
</style>
